export default __webpack_public_path__ + "static/media/NirmalaT.e6dc2555.jpeg";